import {Component, inject, Input, OnInit, Output} from '@angular/core';
import {EventEmitter} from 'events';
import {Router} from '@angular/router';
import {NgxPermissionsService} from 'ngx-permissions';
import {MenuItem} from '../../../../interfaces/data.interfaces';
import {OwnerTypeEnum} from '../../../../enums/data.enums';

@Component({
    selector: 'app-portal-sidebar',
    templateUrl: './portal-sidebar.component.html',
    styleUrls: ['./portal-sidebar.component.scss'],
    standalone: false
})
export class PortalSidebarComponent implements OnInit {

  @Output() x: EventEmitter;

  @Input() menuItems: MenuItem[];
  @Input() moduleName: string;
  @Input() ownerType: OwnerTypeEnum;

  router = inject(Router);
  permissionService = inject(NgxPermissionsService);

  userPermissions = this.permissionService.getPermissions();


  ngOnInit(): void {
  }

  getChildrenPermission(children: MenuItem[]): boolean {
    const permissionsExist = [];
    children?.forEach( c => permissionsExist.push(...c?.permissions));
    return this.has(Object.keys(this.userPermissions), permissionsExist);
  }

  isActiveRoute(children: MenuItem[]) {
    return children?.findIndex( d => d?.route === this.router?.url) > -1;
  }

  protected has(arr: string[], valuesToCheck: string[]): boolean {
    for (const value of valuesToCheck) {
      if (arr.includes(value)) {
        return true;
      }
    }
    return false;
  }

  protected readonly ownerTypeEnum = OwnerTypeEnum;
}
